<div>
  @if (assistantsList().length > 0 || isRegularView) {
    <u-dropdown
      [options]="assistantsList() || []"
      [selectedValue]="selectedAssistantValue()"
      [inTable]="isExtensionView"
      [indicationSelected]="isExtensionView"
      [appendTo]="'body'"
      dropdownSize="large"
      (onChange)="onAssistantSelectOption($event)"
      (onClearAllEvent)="onClearAssistant.emit()"
      [placeholder]="placeholder()"
      [filterPlaceholder]="filterPlaceholder()"
      [styles]="styles()"
      [pTooltip]="tooltip()"
      tooltipPosition="bottom"
      tooltipStyleClass="u-tooltip"
      [iconTemplate]="customIconTemplate"
      [showClearAll]="showClear()"
      showClearAllLabel="Clear selection"
      optionLabel="name"
      [dataKey]="'id'"
      [filter]="assistantsList().length > 8"
    >
    </u-dropdown>
  } @else {
    <div class="current-assistant">
      <ng-container *ngTemplateOutlet="customIconTemplate"></ng-container>
      <span class="assistant-name" [innerHTML]="selectedAssistant()?.name || 'Inactive Assistant'"> </span>
    </div>
  }

  <ng-template #customIconTemplate let-item let-index="index">
    @if (item?.id || item?.isDefault) {
      <assistant-icon
        class="assistant-icon-drop-down"
        [model]="item"
        [iconStyles]="{ fontSize: '14px', width: '16px', height: '16px', display: 'flex' }"
        [spriteEmojiSize]="16"
      ></assistant-icon>
    }
  </ng-template>
</div>
